import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    _createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5 4.017c-.392.021-.67.07-.908.177-.376.17-.682.442-.874.777C3 5.35 3 5.849 3 6.844v.534c0 .995 0 1.493.218 1.874.192.334.498.606.874.776.428.194.988.194 2.108.194h11.6c1.12 0 1.68 0 2.108-.194.376-.17.682-.442.874-.776.218-.38.218-.879.218-1.874v-.534c0-.995 0-1.493-.218-1.873a1.904 1.904 0 00-.874-.777c-.238-.108-.516-.156-.908-.177M3 16.622v.534c0 .995 0 1.493.218 1.873.192.335.498.607.874.777C4.52 20 5.08 20 6.2 20h11.6c1.12 0 1.68 0 2.108-.194.376-.17.682-.442.874-.777.218-.38.218-.878.218-1.873v-.534c0-.995 0-1.493-.218-1.873a1.904 1.904 0 00-.874-.777c-.428-.194-.988-.194-2.108-.194H6.2c-1.12 0-1.68 0-2.108.194-.376.17-.682.442-.874.777C3 15.129 3 15.627 3 16.622zM12 1v6M9 4h6"
    })
  ]))
}